import { useQuery } from 'react-query'
import { useSnackbar } from 'notistack'
import { listEscalations } from 'services/cm-api/list-escalations'
import { EscalationListParams } from 'types'

export function useEscalations(params: EscalationListParams = {}) {
  const { enqueueSnackbar } = useSnackbar()

  return useQuery(['listEscalations', params], () => listEscalations(params), {
    enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
    // Paging and filtering keep the previous page on screen instead of
    // flashing an empty table between requests.
    keepPreviousData: true,
    onError: () => {
      enqueueSnackbar('Failed to fetch escalations', { variant: 'error' })
    },
  })
}
